"use strict";

define('libs/format/string',[], function () {
  var stringFormatter = function stringFormatter(format) {
    return function (value) {
      var str = value || '';
      switch (format) {
        case 'Capitalize':
          str = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
          break;
        case 'UPPERCASE':
          str = str.toUpperCase();
          break;
        case 'lowercase':
          str = str.toLowerCase();
          break;
        default:
          break;
      }
      return str;
    };
  };
  return stringFormatter;
});

